import Vue from 'vue'
import ElementUI from 'element-ui';
import axios from './axios'
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
import router from './router.js';
import { website } from '@/config.js'
import draggable from 'avue-draggable'
import highlight from '@/page/components/highlight'
import { loadScript } from '@/utils/utils'
import App from './App.vue'
import '@/icons/'
import './styles/common.scss'
import '@/utils/es6'
import hljs from 'highlight.js' //导入代码高亮文件
import 'highlight.js/styles/atom-one-dark.css'  //导入代码高亮样式
// import '@/mock/'
//导入主题文件
import '@/theme/index.js'
Vue.config.productionTip = false
window.axios = axios;
window.$loadScript = loadScript;
document.title = website.title
Vue.use(ElementUI);
Vue.use(window.AVUE);
Vue.use(draggable, {
  keys: '联系Avue客服获取'
})
Vue.component('avue-highlight', highlight)
Vue.prototype.$website = website;
const $loadingParams = {};
$loadingParams['element-loading-text'] = "加载中..."
$loadingParams['element-loading-background'] = "rgba(32,32,35, 0.8)"
Vue.prototype.$loadingParams = $loadingParams
Vue.use(dataV)
Vue.directive('highlight', function (el) {
  let highlight = el.querySelectorAll('pre code');
  highlight.forEach((block) => {
    hljs.highlightBlock(block)
  })
});
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
